<template>
  <div class="widget white_box">
    <div class="widget_header">
      <h3 class="tw-text-neutral-900 tw-text-2xl">
        Domain Authority
      </h3>
      <DefaultButton
        v-if="!editing && !preview"
        size="small"
        as="a"
        href="/backlinks/authority"
      >
        See more
      </DefaultButton>
      <div
        v-if="editing && !preview"
        class="edit_buttons"
      >
        <DefaultButton
          size="small"
          variant="danger"
          @click="$parent.remove(widget)"
        >
          Delete
        </DefaultButton>
      </div>
    </div>
    <apexchart
      v-if="!loading"
      :options="chartOptions"
      :series="series"
      height="300"
      type="area"
    />
    <div
      v-else
      class="loading_widget_data"
    >
      <i class="fa fa-btn fa-spinner fa-spin" /> Loading Data
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import axios from 'axios';
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";

export default {
  components: {
    DefaultButton,
  },
  props: {
    editing: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      loading: true,
      series: [],
      options: {
        colors: ['#0c9bef', '#969696'],
        xaxis: {
          categories: [],
          type: 'datetime',
        },
        tooltip: {
          x: {
            format: 'd MMM yyyy',
          }
        }
      }
    }
  },
  computed: {
    ...mapState('dashboard', ['chartBaseOptions', 'uuid', 'preview']),
    chartOptions() {
      return {
        ...this.chartBaseOptions,
        ...this.options
      };
    }
  },
  mounted() {
    axios.post('/ajax/dashboard/get-widget-data', {
      type: 'domainAuthority',
      uuid: this.uuid,
    }).then(response => {
      this.series = response.data.series;
      this.options.xaxis.categories = response.data.categories;
      this.loading = false;
    }).catch(error => {
      console.log(error);
    });
  },
}
</script>
